import { combineReducers } from 'redux'
import theme from './slices/themeSlice'
import footer from './slices/footerSlice'
import auth from './slices/authSlice'
import tabs from './slices/tabSlice'
import menuButton from './slices/menuButtonSlice'
import navigation from './slices/navigationSlice'
import code from './slices/codeSlice'

const rootReducer = asyncReducers => (state, action) => {
  const combinedReducer = combineReducers({
    theme,
    footer,
    auth,
    tabs,
    menuButton,
    navigation,
    code,
    ...asyncReducers,
  })
  return combinedReducer(state, action)
}

export default rootReducer
